import RichText from '@eneco/components/RichText/RichText';
import { ProductConfirmationCardResponse } from '@eneco/dc-be/client';
import { useFormatter } from '@eneco/i18n';
import { Stack } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';
import { EnergyIllustration } from '../../../../components/EnergyIllustration';

export const ProductConfirmationCard = ({ card }: { card: ProductConfirmationCardResponse }) => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const { products } = card.details;
  const energyTypes = new Set(products.map(product => product.energyType));
  const energyType = energyTypes.size === 1 ? Array.from(energyTypes)[0] : 'Both';
  const { format, date } = useFormatter();

  return (
    <StyledDashboardBlock>
      <Stack direction="row" gap={2} alignY="center">
        <Stack.Item shrink={false}>
          <EnergyIllustration energyType={energyType} />
        </Stack.Item>
        <RichText
          html={format(
            fields.productConfirmationCard?.description.value || 'Product confirmation [not in Sitecore] {date}',
            {
              date: date.short(products[0].date),
            },
          )}
        />
      </Stack>
      <DashboardLink
        href={fields.productConfirmationCard?.link.value.href}
        emphasis="high"
        trackingComponentName="product_confirmation_link"
        trackingComponentType="dashboard_link">
        {fields.productConfirmationCard?.link.value.text || 'Link [not in Sitecore]'}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
